module.exports = __webpack_public_path__ + "static/media/ad3.d0395c06.png";